import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Clock, LogOut, RefreshCw } from 'lucide-react';

const SessionWarningDialog = ({ isVisible, timeRemaining, onRenew, onLogout }) => {
  if (!isVisible) return null;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fadeIn">
      <Card className="w-full max-w-md mx-4 shadow-2xl border-2 border-amber-400" data-testid="session-warning-dialog">
        <CardHeader className="text-center pb-2 bg-gradient-to-r from-amber-50 to-orange-50">
          <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-3">
            <Clock className="w-8 h-8 text-white animate-pulse" />
          </div>
          <CardTitle className="text-xl text-amber-800">
            Sessione in Scadenza
          </CardTitle>
          <CardDescription className="text-amber-700">
            La tua sessione sta per scadere
          </CardDescription>
        </CardHeader>
        
        <CardContent className="pt-4 space-y-4">
          <div className="text-center">
            <div className="text-5xl font-bold text-red-600 mb-2" data-testid="session-countdown">
              {formatTime(timeRemaining)}
            </div>
            <p className="text-gray-600">
              Tempo rimanente prima del logout automatico
            </p>
          </div>
          
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
            <p className="text-sm text-amber-800">
              Clicca <strong>"Rinnova Sessione"</strong> per continuare a lavorare, 
              oppure <strong>"Esci"</strong> per effettuare il logout.
            </p>
          </div>
          
          <div className="flex gap-3">
            <Button
              onClick={onLogout}
              variant="outline"
              className="flex-1 border-gray-300 hover:bg-gray-100"
              data-testid="logout-button"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Esci
            </Button>
            <Button
              onClick={onRenew}
              className="flex-1 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white"
              data-testid="renew-session-button"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Rinnova Sessione
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SessionWarningDialog;
